module.exports = __webpack_public_path__ + "media/images/library-4bcf57376de91db150e98a1014f4aae3.png";